export enum CommentType {
    text = 0,
    image = 1,
    audio = 2
};
